import React from 'react'

const Heading = ({ text, style }) => {
    if (!text) return null
    return (
        <h2 className='py-1 text-center text-base sm:text-xl md:text-2xl lg:text-3xl font-bold uppercase'>{text}</h2>
    )
}

export default Heading